import React from "react";
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Input
} from "reactstrap";
import styles from "../Styles/search-job.css";
import FilterIcon from "../images/filter-icon.png";
import AppConstants from "../AppConstants.js";
import axios from "axios";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactPaginate from "react-paginate";

import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import $ from "jquery";
import Leaflet from "./Leaflet.js";
import { BiBookmark } from "react-icons/bi";
import { BsFillBookmarkFill } from "react-icons/bs";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinIcon,
  LinkedinShareButton
} from "react-share";
import { FaClone } from "react-icons/fa";
import {
  NotificationContainer,
  NotificationManager
} from "react-notifications";
import ContactRecruiterPopUp from "./contact_recruiter.js";

import queryString from "query-string";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import ".././Styles/common.css";

import Filters from "./Filters.js";
var refreshVal = "";
if (window.performance) {
  if (performance.navigation.type == 1) {
    refreshVal = "val";
  } else {
    refreshVal = "";
  }
}
class JobsDashboard extends React.Component {
  constructor(props) {
    super(props);
    const workItem = localStorage.getItem("workType");

    const query1 = queryString.parse(this.props.location.search);

    this.state = {
      jobList: [],
      jobListdata: false,
      currentPage: 1,
      pageSizes: [5, 10, 20, 50, 100],
      selectedPageSize: 50,
      searchText: "",
      speciality: "",
      location: "",
      state: "",
      city: "",
      cityval: "",
      cityState: "",
      shift: [],
      searchRadius: "20",
      searchPlaceHolder: "Search",
      stateDuplicate: "",
      totalItemCount: "",
      specialities: [],
      cities: [],
      states: [],
      check_duration: [],
      shiftDropdown: "",
      durationDropdown: "",
      hotJobsFlag: false,
      strData: [],
      type: query1 && query1.workType ? query1.workType : "0",

      selectedShifts: [],

      selectedDuration: [],
      duration: [],
      startDate: "",
      toStartDate: "",
      cbspeciality: [],
      dropdownStatus: false,
      toDateError: "",
      subFilterStatus: false,
      sortVals: ["Select", "Highest Gross", "Lowest Gross"],
      selectedGrossSort: "Highest Gross",
      modal: false,
      certification: [],
      showUserPopUp: false,
      activeTab: "1",
      stateCodeArray: [],
      certificationArray: [],
      specialityArray: [],
      userInfo: {},
      clearFilters: true,
      activeSortTab: "grossPay"
    };

    this.handlePageValues = this.handlePageValues.bind(this);

    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    if (
      (this.props,
      window.innerWidth >= 320 && this.props,
      window.innerWidth <= 767)
    ) {
      this.setState({ dropdownStatus: true, subFilterStatus: true });
    }
    let user = JSON.parse(localStorage.getItem("userInfo"));
    this.setState({ userInfo: user });
    if (this.props.location.search !== "") {
      var query = queryString.parse(this.props.location.search);
      var resertUrl = this.props.location?.search;
      const query123 = resertUrl && resertUrl.split("&")[0];
      if (
        this.props.location?.search == "?hotjobs=1" ||
        query123 == "?hotjobs=1"
      ) {
        this.setState({ hotJobsFlag: true });
      }
      this.updateJobsList(
        this.state.currentPage,
        this.state.selectedPageSize,
        this.state.activeSortTab,
        this.state.searchText,
        query.speciality ? query.speciality.split(",") : [],
        query.state ? query.state.split(",") : [],
        query.city ? query.city : "",
        this.state.shift,
        query.radius ? query.radius : "",
        this.state.duration,
        this.state.startDate,
        this.state.toStartDate,
        query.certification ? query.certification.split(",") : [],
        query.workType ? query.workType : this.state.type
      );

      this.setState({
        speciality: query.speciality ? query.speciality.split(",") : [],
        certification: query.certification
          ? query.certification.split(",")
          : [],
        state: query.state ? query.state.split(",") : [],
        city: query.city ? query.city : "",
        radius: query.radius ? query.radius : ""
      });
    } else if (
      this.props.location.state !== "" &&
      this.props.location.state !== null &&
      this.props.location.state !== undefined &&
      this.props.location.state !== "undefined" &&
      refreshVal === ""
    ) {
      var newState = this.props.location.state;

      this.updateJobsList(
        this.state.currentPage,
        this.state.selectedPageSize,
        this.state.activeSortTab,
        this.state.searchText,
        newState && newState.speciality ? newState.speciality : [],
        newState.state ? newState.state : [],
        newState.city ? newState.city : "",
        this.state.shift,
        newState.radius ? newState.radius : "",
        this.state.duration,
        this.state.startDate,
        this.state.toStartDate,
        newState.certification ? newState.certification : [],
        this.state.type
      );
      this.setState({
        speciality: newState.speciality ? newState.speciality : [],
        certification: newState.certification ? newState.certification : [],
        state: newState.state ? newState.state : [],
        city: newState.city ? newState.city : "",
        radius: newState.radius ? newState.radius : ""
      });
    } else {
      var sizeperPage;
      if (
        (this.props,
        window.innerWidth >= 320 && this.props,
        window.innerWidth <= 767)
      ) {
        this.setState({
          selectedPageSize: 5
        });
        sizeperPage = 5;
      }
      this.updateJobsList(
        this.state.currentPage,
        sizeperPage,
        this.state.activeSortTab,
        this.state.searchText,
        this.state.speciality,
        this.state.state,
        this.state.city,
        this.state.shift,
        this.state.searchRadius,
        this.state.duration,
        this.state.startDate,
        this.state.toStartDate,
        this.state.certification,
        this.state.type
      );
    }
  }
  handlePageValues(e) {
    this.setState({ [e.target.name]: parseInt(e.target.value) }, () => {
      this.onChangePage(1);
    });
    let page = 1;
    this.updateJobsList(
      page,
      parseInt(e.target.value),
      this.state.activeSortTab,
      this.state.searchText,
      this.state.speciality,
      this.state.state,
      this.state.city,
      this.state.shift,
      this.state.searchRadius,
      this.state.duration,
      this.state.startDate,
      this.state.toStartDate,
      this.state.certification,
      this.state.type
    );
  }
  handleOnFocus(e) {
    this.setState({ searchPlaceHolder: "" });
  }
  handleOnBlur(e) {
    this.setState({ searchPlaceHolder: "Search" });
  }

  onChangePage = (page) => {
    this.setState({
      currentPage: page
    });
    window.scrollTo(0, 0);
  };

  updateJobsList = async (
    currentPage,
    selectedPageSize,
    selectedOrderOption,
    searchText,
    speciality,
    // location,
    state,
    city,
    shift,
    searchRadius,
    duration,
    startDate,
    toStartDate,
    certification,
    type
  ) => {
    console.log(
      "updateJobsList",
      searchText,
      certification,
      speciality,
      "workType-------->",
      type
    );
    let nurseId = localStorage.getItem("id");
    if (searchText && searchText !== "") {
      searchText = searchText;
    } else {
      searchText = "";
      this.setState({ jobListdata: false });
    }
    var stateVal = [];
    if (state) {
      state.map((item) => {
        if (item.code) {
          stateVal.push(item.code);
        } else {
          stateVal.push(item);
        }
      });
    }
    var specialityVal = [];
    if (speciality && speciality.length > 0) {
      speciality.map((item) => {
        if (item.value) {
          specialityVal.push(item.value);
          this.setState({ specialityArray: specialityVal });
        } else {
          specialityVal.push(item);
        }
      });
    }
    var certVal = [];
    if (certification) {
      certification.map((item) => {
        if (item.value) {
          certVal.push(item.value);
          this.setState({ certificationArray: certVal });
        } else {
          certVal.push(item);
        }
      });
    }
    if (shift) {
      var shiftVal = [];
      shift.map((item) => {
        shiftVal.push(item);
      });
    }
    if (duration) {
      var durationVal = [];
      duration.map((item) => {
        durationVal.push(item.value);
      });
    }
    var cityName = "";
    if (city) {
      cityName = city.split(", ");
      this.setState({ cityState: cityName[1] });
      this.setState({ cityval: cityName[0] });
    }
    var sizeperpage = selectedPageSize;
    if (selectedPageSize === "undefined" || selectedPageSize === undefined) {
      sizeperpage =
        window.innerWidth >= 320 && window.innerWidth <= 767 ? 5 : 50;
    }
    var resertUrl = this.props.location?.search;

    const queryString = resertUrl && resertUrl.split("&")[0];

    let tablefilterdata = nurseId
      ? {
          page: currentPage,
          sizeperpage: sizeperpage,
          sortname: this.state.activeSortTab,
          searchtext: searchText,
          defaultSearchText: searchText,
          speciality: specialityVal,
          state: stateVal,
          city: cityName[0],
          cityFullName: city,
          cityState: city ? cityName[1] : "",
          shift: shiftVal,
          searchRadius: cityName[0] ? searchRadius : "",
          duration: durationVal,
          startDate: startDate,
          toStartDate: toStartDate,
          certification: certVal,
          pinned: this.state.hotJobsFlag,
          nurseId: nurseId ? nurseId : "",
          workType: type,
          hotJobs:
            this.props.location?.search == "?hotjobs=1" ||
            queryString == "?hotjobs=1"
              ? true
              : false
        }
      : {
          page: currentPage,
          sizeperpage: sizeperpage,
          sortname: this.state.activeSortTab,
          searchtext: searchText,
          defaultSearchText: searchText,
          speciality: specialityVal,
          state: stateVal,
          city: cityName[0],
          cityFullName: city,
          cityState: city ? cityName[1] : "",
          shift: shiftVal,
          searchRadius: cityName[0] ? searchRadius : "",
          duration: durationVal,
          startDate: startDate,
          toStartDate: toStartDate,
          certification: certVal,
          pinned: this.state.hotJobsFlag,
          workType: type,
          hotJobs:
            this.props.location?.search == "?hotjobs=1" ||
            queryString == "?hotjobs=1"
              ? true
              : false
        };
    this.setState({ jobListdata: false });

    await axios
      .post(AppConstants.Jobs_API + "/api/jobs/get-all-jobs", tablefilterdata)
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        if (data.Status === "Success") {
          var list = data.data;
          var newlist = [];

          this.setState({
            jobListdata: true,
            strData: newlist,
            totalPage: data.totalPage,
            jobList: data.data,
            pointerSm: `${AppConstants.Bucket_URL}/bannerImages/pointer-small.png`,
            selectedItems: [],
            totalItemCount: data.total_records
          });
        }
      });
  };
  handlePageClick = (data) => {
    this.onChangePage(data.selected + 1);
    this.updateJobsList(
      data.selected + 1,
      this.state.selectedPageSize,
      this.state.activeSortTab,
      this.state.searchText,
      this.state.speciality,
      this.state.state,
      this.state.city,
      this.state.shift,
      this.state.searchRadius,
      this.state.duration,
      this.state.startDate,
      this.state.toStartDate,
      this.state.certification,
      this.state.type
    );
  };

  jobClass() {
    $(".search-bar").toggleClass("bar-open");
  }

  handleModal() {
    this.setState({ modal: !this.state.modal });
  }
  handlePopUp() {
    this.setState({ modal: true });
  }
  userPopCallback = (val) => {
    this.setState({ showUserPopUp: val });
  };
  handleUserPopup(e) {
    e.preventDefault();
    this.setState({ showUserPopUp: true });
  }
  handleUserModelPopup() {
    this.setState({ showUserPopUp: !this.state.showUserPopUp });
  }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  hotJobsList = async () => {
    var query = queryString.parse(this.props.location.search);
    const searchParams = new URLSearchParams(this.props.location.search);
    searchParams.delete("hotjobs");
    const newPath = searchParams.toString();
    if (!this.state.hotJobsFlag) {
      var path = newPath ? "?hotjobs=1&" : "?hotjobs=1";
      this.props && this.props.history.push(`${path}${newPath}`);
      await this.setState({ hotJobsFlag: true, currentPage: 1 });
      await this.updateJobsList(
        1,
        this.state.selectedPageSize,
        this.state.activeSortTab,
        this.state.searchText,
        query.speciality ? query.speciality.split(",") : [],
        query.state ? query.state.split(",") : [],
        query.city ? query.city : "",
        this.state.shift,
        query.radius ? query.radius : "",
        this.state.duration,
        this.state.startDate,
        this.state.toStartDate,
        query.certification ? query.certification.split(",") : [],
        query.workType ? query.workType : this.state.type
      );
    } else {
      this.props && this.props.history.push(`/?${newPath}`);
      await this.setState({ hotJobsFlag: false, currentPage: 1 });
      await this.updateJobsList(
        1,
        this.state.selectedPageSize,
        this.state.activeSortTab,
        this.state.searchText,
        query.speciality ? query.speciality.split(",") : [],
        query.state ? query.state.split(",") : [],
        query.city ? query.city : "",
        this.state.shift,
        query.radius ? query.radius : "",
        this.state.duration,
        this.state.startDate,
        this.state.toStartDate,
        query.certification ? query.certification.split(",") : [],
        query.workType ? query.workType : this.state.type
      );
    }
  };

  handleSaveJobClick = async (e, id) => {
    let nurseId = localStorage.getItem("id");
    await axios
      .post(AppConstants.API + "/api/nurse/save-job", {
        nurseId: nurseId,
        jobId: id
      })
      .then((response) => {
        NotificationManager.success(response.data.msg, "", 3000);
        this.updateJobsList(
          1,
          this.state.selectedPageSize,
          this.state.activeSortTab,
          this.state.searchText,
          this.state.speciality,
          this.state.state,
          this.state.city,
          this.state.shift,
          this.state.searchRadius,
          this.state.duration,
          this.state.startDate,
          this.state.toStartDate,
          this.state.certification,
          this.state.type
        );
      });
  };

  replaceURL(url) {
    if (!url) {
      url =
        "https://travelnurses.s3.us-west-2.amazonaws.com/default-job-image.png";
    }
    const replaced = url.replace(
      "https://travelnurses.s3.us-west-2.amazonaws.com",
      AppConstants.Bucket_URL
    );
    return replaced;
  }

  handleFilterChange = (filterData) => {
    console.log("Received filter data:", filterData);
    const {
      searchText,
      speciality,
      state,
      cityFullName,
      shift,
      searchRadius,
      duration,
      startDate = "",
      toStartDate = "",
      certification,
      workType
    } = filterData;

    this.setState({
      searchText: searchText,
      certification: certification,
      type: workType,
      speciality: speciality,
      state: state,
      city: cityFullName,
      shift: shift,
      searchRadius: searchRadius,
      duration: duration
    });

    // Call Jobs List API here
    this.updateJobsList(
      1,
      this.state.selectedPageSize,
      this.state.activeSortTab,
      searchText,
      speciality,
      state,
      cityFullName,
      shift,
      searchRadius,
      duration,
      startDate,
      toStartDate,
      certification,
      workType
    );
  };

  handleSortTabClick = (sortType) => {
    this.setState({ activeSortTab: sortType, currentPage: 1 });
    console.log(sortType);
    let sortOrder = "";
    switch (sortType) {
      case "grossPay":
        sortOrder = "grossPay";
        break;
      case "createdDate":
        sortOrder = "createdDate";
        break;

      default:
        sortOrder = "grossPay";
        break;
    }

    this.updateJobsList(
      1, // reset to first page
      this.state.selectedPageSize,
      sortOrder, // pass the sort order
      this.state.searchText,
      this.state.speciality,
      this.state.state,
      this.state.city,
      this.state.shift,
      this.state.searchRadius,
      this.state.duration,
      this.state.startDate,
      this.state.toStartDate,
      this.state.certification,
      this.state.type
    );
  };

  render() {
    let nurseId = localStorage.getItem("id");

    console.log(this.state.searchText, "searchText");
    return (
      <div className="searchjobs-block pb-50 board-area">
        <Helmet>
          <title>
            Travel Nurses Jobs, Nurse Job Opportunities | Travel Nurses Inc
          </title>
          <meta name="title" content="Jobs" />
          <meta
            name="description"
            content="Travel Nurses Jobs |Travel Nurses Inc has thousands of Nurse and RN jobs with healthcare facilities, All 50 States. Great Benefits & Pay. Apply now!"
          />

          <meta property="og:type" content="website" />

          <meta property="og:url" content={AppConstants.Base_Url + "/"} />
          <meta property="og:title" content="Jobs" />
          <meta
            property="og:description"
            content="Travel Nurses Jobs |Travel Nurses Inc has thousands of Nurse and RN jobs with healthcare facilities, All 50 States. Great Benefits & Pay. Apply now!"
          />
          <meta
            property="og:image"
            content="https://travelnurses.s3-us-west-2.amazonaws.com/static/logo.jpg"
          />

          <meta
            property="twitter:card"
            content="https://travelnurses.s3-us-west-2.amazonaws.com/static/logo.jpg"
          />
          <meta property="twitter:url" content={AppConstants.Base_Url + "/"} />
          <meta property="twitter:title" content="Jobs" />
          <meta
            property="twitter:description"
            content="Travel Nurses Jobs |Travel Nurses Inc has thousands of Nurse and RN jobs with healthcare facilities, All 50 States. Great Benefits & Pay. Apply now!"
          />
          <meta
            property="twitter:image"
            content="https://travelnurses.s3-us-west-2.amazonaws.com/static/logo.jpg"
          />
        </Helmet>

        <div className="main-content latestjobs" id="advanced-search">
          <Container>
            <div className="inner-content mt-0">
              <div className="custom-job-board-message text-center">
                <strong>
                  Pardon our dust! Our job board is live but not running at full
                  power. We’re working behind the scenes to bring back full job
                  transparency ASAP. Thanks for your patience!
                </strong>{" "}
              </div>

              <h1 className="main-title-sub" style={{ padding: "6px 0 15px" }}>
                Travel Nurse Job Board
              </h1>

              {/* Jobs List Block Start Here */}

              <Tabs
                defaultActiveKey={"1"}
                onSelect={(k) => this.handleChangeList(k)}
                id="uncontrolled-tab-example"
                className="mb-3 job-tab-grid"
              >
                <Tab eventKey="1">
                  <div className="row">
                    <aside className="tab-left-filter col-xl-3 mb-3 mb-3">
                      <Filters onFilterChange={this.handleFilterChange} />
                    </aside>
                    <aside className="tab-right-body col-xl-9">
                      <div className="job-tab job-tab-cont">
                        <div className="row">
                          <div className="job-result-count1 col-12 job-tabs-result">
                            <Row className="justify-content-between mb-2">
                              <Col className="result-cont my-auto col-md-6 ">
                                {this.state.activeTab === "1" &&
                                  (this.state.totalItemCount ? (
                                    <h4>
                                      {this.state.searchText ? (
                                        <>
                                          Results: {this.state.totalItemCount}{" "}
                                          Travel Nurse Jobs Found for{" "}
                                          <span
                                            style={{
                                              color: "#25408f",
                                              fontWeight: "700"
                                            }}
                                          >
                                            {this.state.searchText}
                                          </span>
                                        </>
                                      ) : this.state.totalItemCount === 1 ? (
                                        "Results: 1 Travel Nurse Job Found"
                                      ) : (
                                        `Results: ${this.state.totalItemCount} Travel Nurse Jobs Found`
                                      )}
                                    </h4>
                                  ) : null)}
                                <></>
                              </Col>

                              <Col className="count-drop text-right col-md-6">
                                <em class="my-auto">Sort By</em>
                                <ul>
                                  <li
                                    className={
                                      this.state.activeSortTab === "grossPay"
                                        ? "active"
                                        : ""
                                    }
                                    onClick={() =>
                                      this.handleSortTabClick("grossPay")
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <span>Highest Est. Compensation</span>
                                  </li>
                                  <li
                                    className={
                                      this.state.activeSortTab === "createdDate"
                                        ? "active"
                                        : ""
                                    }
                                    onClick={() =>
                                      this.handleSortTabClick("createdDate")
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <span>Latest Listings</span>
                                  </li>
                                </ul>
                              </Col>
                            </Row>
                          </div>
                          <Nav tabs className="main-tab-sec">
                            {/* <div
                              className={`my-auto ml-2 ml-auto mbl-hot-job hot-job ${
                                this.state.hotJobsFlag && `active`
                              }`}
                              style={{ color: "rgb(35, 63, 143)" }}
                            >
                              <button
                                type="button"
                                style={{
                                  background: "none",
                                  border: "none",
                                  padding: 0,
                                  margin: 0,
                                  color: "inherit",
                                  font: "inherit",
                                  cursor: "pointer"
                                }}
                                onClick={this.hotJobsList.bind(this)}
                              >
                                <span>Hot Jobs</span>
                                <img
                                  src="https://df8de9x9ieyx9.cloudfront.net/bannerImages/tn-flame.gif"
                                  style={{ width: "40px" }}
                                  alt="Hot Jobs Flame"
                                />
                              </button>
                            </div> */}

                            <div className="form-group">
                              <label
                                className="text-left pr-3"
                                style={{
                                  color: "#233f8f",
                                  fontWeight: "700"
                                }}
                              >
                                Show
                              </label>
                              <select
                                style={{
                                  width: "auto"
                                }}
                                className="select-box w-auto d-inline"
                                value={this.state.selectedPageSize}
                                name="selectedPageSize"
                                onChange={this.handlePageValues}
                              >
                                {this.state.pageSizes.map((page, index) => {
                                  return (
                                    <option id={index} value={page}>
                                      {page}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <NavItem className="tab-block">
                              <NavLink
                                className={classnames({
                                  active: this.state.activeTab === "1"
                                })}
                                onClick={() => {
                                  this.toggle("1");
                                }}
                              >
                                <figure>
                                  <img
                                    src="https://df8de9x9ieyx9.cloudfront.net/bannerImages/list-icon-new.png"
                                    alt="list-icon"
                                  />
                                </figure>
                              </NavLink>
                            </NavItem>
                            {/* <NavItem className="tab-block">
                              <NavLink
                                className={classnames({
                                  active: this.state.activeTab === "2"
                                })}
                                onClick={() => {
                                  this.toggle("2");
                                }}
                              >
                                <figure>
                                  <img
                                    src="https://df8de9x9ieyx9.cloudfront.net/bannerImages/map-black-icon.png"
                                    alt="list-icon"
                                  />
                                </figure>
                              </NavLink>
                            </NavItem> */}
                          </Nav>
                        </div>

                        <TabContent activeTab={this.state.activeTab}>
                          <TabPane tabId="1">
                            {this.state.jobListdata === true ? (
                              <div
                                className="list-job pb-50"
                                id="jobs-list-grid"
                              >
                                {this.state.jobList.length !== 0 ? (
                                  this.state.jobList.map((item, index) => (
                                    <div className="job-info block-box">
                                      <div
                                        className="share-btn position-absolute bg-white share-rotate111"
                                        style={{
                                          right: "10px",
                                          top: "8px"
                                        }}
                                      >
                                        <span
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          title="Slide to left"
                                          // href="#"
                                          class="button-share pr-0 d-flex"
                                        >
                                          <span class="icon-share">
                                            <i
                                              class="fa fa-share-alt"
                                              aria-hidden="true"
                                            ></i>
                                          </span>
                                          <span class="text">
                                            <Row className="pr-2 mr-0">
                                              <Col
                                                className="rounded-left text-white text-center px-1 pt-1 "
                                                style={{
                                                  background: "#25408f"
                                                }}
                                              >
                                                <NotificationContainer />
                                                <FaClone
                                                  className=""
                                                  // onClick={this.copyCodeToClipboard.bind(
                                                  //   this,
                                                  //   item._id
                                                  // )}
                                                />
                                              </Col>
                                              <Col
                                                className="pl-0 pr-2"
                                                style={{
                                                  background: "#00aced"
                                                }}
                                              >
                                                <span className="twitter">
                                                  <TwitterShareButton
                                                    url={
                                                      AppConstants.Base_Url +
                                                      `/job/${item.bullhornJobId}`
                                                    }
                                                    imageURL="https://travelnurses.s3-us-west-2.amazonaws.com/static/logo.jpg"
                                                    className="share"
                                                    title={`${item.title} Job in ${item.city}, ${item.state}\n Travel Nurses, Inc. has an opportunity open for a ${item.title} to work ${item.duration} weeks in ${item.city}, ${item.state}. Apply now to start your next adventure with great benefits, fair pay, and a supportive team behind you!`}
                                                  >
                                                    <TwitterIcon
                                                      size={32}
                                                      round={true}
                                                    />
                                                  </TwitterShareButton>
                                                </span>
                                              </Col>
                                              <Col
                                                className="pl-0 pr-2 "
                                                style={{
                                                  background: "#405992"
                                                }}
                                              >
                                                <span className="facebook">
                                                  <FacebookShareButton
                                                    url={
                                                      AppConstants.Base_Url +
                                                      `/job/${item.bullhornJobId}`
                                                    }
                                                    imageURL="https://travelnurses.s3-us-west-2.amazonaws.com/static/logo.jpg"
                                                    className="share w-100"
                                                    quote={`${item.title} Job in ${item.city}, ${item.state}\n Travel Nurses, Inc. has an opportunity open for a ${item.title} to work ${item.duration} weeks in ${item.city}, ${item.state}. Apply now to start your next adventure with great benefits, fair pay, and a supportive team behind you!`}
                                                  >
                                                    <FacebookIcon
                                                      size={32}
                                                      round={true}
                                                    />
                                                  </FacebookShareButton>
                                                </span>
                                              </Col>
                                              <Col
                                                className="pl-0 pr-2 rounded-right"
                                                style={{
                                                  background: "#007fb1"
                                                }}
                                              >
                                                <LinkedinShareButton
                                                  url={
                                                    AppConstants.Base_Url +
                                                    `/job/${item.bullhornJobId}`
                                                  }
                                                  className="share"
                                                  title={`${item.title} Job in ${item.city}, ${item.state} `}
                                                  summary={`Travel Nurses, Inc. has an opportunity open for a ${item.title} to work ${item.duration} weeks in ${item.city}, ${item.state}. Apply now to start your next adventure with great benefits, fair pay, and a supportive team behind you!`}
                                                  media="https://travelnurses.s3-us-west-2.amazonaws.com/static/logo.jpg"
                                                >
                                                  <LinkedinIcon
                                                    size={32}
                                                    round={true}
                                                  />
                                                </LinkedinShareButton>
                                              </Col>
                                            </Row>
                                          </span>
                                        </span>
                                      </div>

                                      <ul>
                                        <Link
                                          to={{
                                            pathname: `/job/${item.bullhornJobId}`,
                                            state: {
                                              speciality: this.state.speciality
                                                ? this.state.speciality
                                                : "",
                                              city: this.state.city
                                                ? this.state.city
                                                : "",
                                              state: this.state.stateDuplicate
                                                ? this.state.stateDuplicate
                                                : "",
                                              searchRadius: this.state
                                                .searchRadius
                                                ? this.state.searchRadius
                                                : ""
                                            }
                                          }}
                                          target="_blank"
                                        >
                                          <li className="job-location ">
                                            <img
                                              src={this.replaceURL(
                                                item.stateImages[
                                                  Math.floor(
                                                    Math.random() *
                                                      item.stateImages.length
                                                  )
                                                ]
                                              )}
                                              alt={`${item.title} - ${item.city}, ${item.state}`}
                                            />
                                          </li>
                                        </Link>
                                        <li className="job-position pt-4">
                                          <h4
                                            style={{
                                              fontSize: "25px",
                                              color: "#333333"
                                            }}
                                          >
                                            {item.degree}
                                          </h4>
                                          {item.jobSubSpeciality ? (
                                            <p
                                              style={{
                                                fontSize: "23px",
                                                color: "#707070"
                                              }}
                                            >
                                              {item.jobSubSpeciality}
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                          <span className="city-name">
                                            {item.city + ", " + item.state}
                                          </span>
                                        </li>
                                        <li className="job-time">
                                          <p className="date">
                                            <span>
                                              Start Date:{" "}
                                              <em>{item.start_date}</em>
                                            </span>
                                          </p>
                                          {item.workType !== "2" && (
                                            <p className="duration">
                                              <span>
                                                Duration:{" "}
                                                <em>
                                                  {item.duration
                                                    ? item.duration == 1
                                                      ? item.duration + " Week"
                                                      : item.duration + " Weeks"
                                                    : "N/A"}
                                                </em>
                                              </span>
                                            </p>
                                          )}
                                          <p className="time">
                                            <span>{item.shift}</span>
                                          </p>
                                        </li>
                                        <li className="btn-section  pt-0 pt-lg-4 pt-md-4">
                                          {/* {item.grossPay1 === 0 ? ( */}
                                          {item.grossPay1 < 500 ? (
                                            ""
                                          ) : (
                                            <div className="empty-class">
                                              {nurseId &&
                                                item.workType == "1" && (
                                                  <div
                                                    className={`saved-text ${
                                                      item.isSaved
                                                        ? ""
                                                        : "addSavedClass"
                                                    }`}
                                                  >
                                                    <button
                                                      onClick={(e) =>
                                                        this.handleSaveJobClick(
                                                          e,
                                                          item._id
                                                        )
                                                      }
                                                    >
                                                      {item.isSaved ? (
                                                        <BsFillBookmarkFill />
                                                      ) : (
                                                        <BiBookmark />
                                                      )}
                                                      <span>
                                                        {item.isSaved
                                                          ? "Remove"
                                                          : "Save"}
                                                      </span>
                                                    </button>
                                                  </div>
                                                )}
                                              <p className="est-pay-res pb-0 text-right mr-3">
                                                <div className="est-pay-res-in text-left">
                                                  <h4
                                                    style={{ fontSize: "16px" }}
                                                    className="pb-0"
                                                  >
                                                    Est.pay
                                                    <span className="dollar-sign mx-1">
                                                      &#36;
                                                    </span>
                                                    {/* <span className="currency d-black w-100"></span> */}
                                                  </h4>

                                                  <h4
                                                    className="pb-0"
                                                    style={{ color: "#333333" }}
                                                  >
                                                    <span
                                                      style={{
                                                        fontSize: "27px",
                                                        fontWeight: "bold"
                                                      }}
                                                    >
                                                      {"$" + item.grossPay1}
                                                    </span>
                                                    /<span>week</span>
                                                  </h4>
                                                </div>
                                              </p>
                                            </div>
                                          )}
                                          <Link
                                            className="lead-link jobdetail_link"
                                            to={{
                                              pathname: `/job/${item.bullhornJobId}`,
                                              search: queryString.stringify({
                                                certification:
                                                  item.certification || "",
                                                speciality:
                                                  item.jobSubSpeciality || "",
                                                workType: item.workType || ""
                                              }),
                                              state: {
                                                speciality: this.state
                                                  .speciality
                                                  ? this.state.speciality
                                                  : [],
                                                city: this.state.city
                                                  ? this.state.city
                                                  : [],
                                                state: this.state.stateDuplicate
                                                  ? this.state.stateDuplicate
                                                  : [],
                                                searchRadius: this.state
                                                  .searchRadius
                                                  ? this.state.searchRadius
                                                  : "",
                                                specialities: this.state
                                                  .specialities
                                                  ? this.state.specialities
                                                  : "",
                                                cities: this.state.cities
                                                  ? this.state.cities
                                                  : "",
                                                states: this.state.states
                                                  ? this.state.states
                                                  : "",
                                                duration: this.state.duration,
                                                shift: this.state.shift,
                                                selectedPageSize:
                                                  this.state.selectedPageSize,
                                                currentPage:
                                                  this.state.currentPage,
                                                searchText:
                                                  this.state.searchText,
                                                // check_duration: this.state.check_duration,
                                                selectedDuration:
                                                  this.state.selectedDuration,
                                                selectedShifts:
                                                  this.state.selectedShifts,
                                                startDate: this.state.startDate,
                                                toStartDate:
                                                  this.state.toStartDate,
                                                jobDetailPath: "/job/:id",
                                                pnr: false
                                              }
                                            }}
                                          >
                                            View Details
                                          </Link>
                                          <Link
                                            to={{
                                              pathname: `/apply-job/${item.bullhornJobId}`
                                            }}
                                            className="button mt-4 mt-md-0 mt-lg-0 text-center"
                                            target="_blank"
                                          >
                                            Apply
                                          </Link>
                                        </li>
                                      </ul>
                                    </div>
                                  ))
                                ) : (
                                  <span className="no-data">
                                    {/* No jobs match this criteria. */}
                                    Sorry, looks like we don’t have any of those
                                    jobs available at the moment. <br />
                                    Jobs refresh hourly, so let's find you a
                                    match!
                                    <br />
                                    <Button
                                      onClick={this.handlePopUp.bind(this)}
                                    >
                                      Submit a request to be notified for
                                      openings
                                    </Button>
                                    {this.state.modal === true ? (
                                      <ContactRecruiterPopUp
                                        workType={this.state.type}
                                        modal={this.state.modal}
                                        speciality={this.state.speciality}
                                        certification={this.state.certification}
                                        city={this.state.city}
                                        state={this.state.state}
                                        searchText={this.state.searchText}
                                        selectedDurationShifts={this.state.selectedDuration.concat(
                                          this.state.selectedShifts
                                        )}
                                        searchRadius={this.state.searchRadius}
                                        dateRegion={
                                          this.state.startDate &&
                                          this.state.toStartDate
                                            ? moment(
                                                this.state.startDate
                                              ).format("MMM DD YY") +
                                              " - " +
                                              moment(
                                                this.state.toStartDate
                                              ).format("MMM DD YY")
                                            : ""
                                        }
                                        title="Requesting Job Match"
                                        handleModal={this.handleModal.bind(
                                          this
                                        )}
                                        // specialities = {this.props.location.state.speciality}
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </span>
                                )}
                              </div>
                            ) : (
                              <div className="list-job pb-50 loader-center">
                                {" "}
                                <img
                                  src={`${AppConstants.Bucket_URL}/bannerImages/loader.gif`}
                                  alt="No Image - Travel Nurses Inc"
                                  className="loader-center"
                                  style={{ width: 80, height: 80 }}
                                />{" "}
                              </div>
                            )}
                            {/* Jobs List Block End Here */}
                            {this.state.jobList.length !== 0 ? (
                              <div className="filter-blk bottom-filter">
                                <ReactPaginate
                                  breakLabel={"....."}
                                  breakClassName={"break-me pt-2 false mx-0"}
                                  pageCount={this.state.totalPage}
                                  marginPagesDisplayed={
                                    (this.props,
                                    window.innerWidth >= 320 && this.props,
                                    window.innerWidth <= 767 ? 1 : 2)
                                  }
                                  pageRangeDisplayed={
                                    (this.props,
                                    window.innerWidth >= 320 && this.props,
                                    window.innerWidth <= 767 ? 1 : 3)
                                  }
                                  forcePage={this.state.currentPage - 1}
                                  onPageChange={this.handlePageClick}
                                  containerClassName={
                                    "pagination pagination-blk d-flex"
                                  }
                                  subContainerClassName={
                                    "pages pagination page-item "
                                  }
                                  disabledClassName={"disabledcustom-pagi"}
                                  previousLinkClassName={
                                    "prve-next search-prev  page-link"
                                  }
                                  nextLinkClassName={
                                    "next-next search-next prve-next page-link"
                                  }
                                  activeClassName={"active"}
                                  pageClassName={"false page-link"}
                                  pageLinkClassName={"anchor class"}
                                />
                                <div className="clear"></div>
                              </div>
                            ) : (
                              ""
                            )}
                          </TabPane>
                          <TabPane tabId="2">
                            <Leaflet
                              hotJobsFlag={this.state.hotJobsFlag}
                              filters={{
                                certification: this.state.certificationArray,
                                speciality: this.state.specialityArray,
                                city: this.state.cityval,
                                cityState: this.state.cityState,
                                state: this.state.stateCodeArray,
                                searchRadius: this.state.searchRadius,
                                shift: this.state.shift
                              }}
                            />
                          </TabPane>
                        </TabContent>
                      </div>
                    </aside>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </Container>
        </div>
      </div>
    );
  }
}
export default JobsDashboard;
